const ScratchMicrobitDevice = require('./microbit');

/**
  * Scratch blocks to interact with a Microbit V2 peripheral.
  */
class ScratchMicrobitV2Device extends ScratchMicrobitDevice{

    /**
      * @return {string} - the ID of this extension.
      */
    get DEVICE_ID () {
        return 'microbitV2';
    }
}

module.exports = ScratchMicrobitV2Device;
